import { z } from 'zod';

import { Features } from '../types/features';
import { SubscriptionPlan } from '../types/subscription-plan';
import { SubscriptionStatus } from '../types/subscription-status';

import { IBaseEntity } from './base-entity.interface';
import { Organization, OrganizationId } from './organization.interface';

export const SubscriptionIdSchema = z.string().brand('SubscriptionId');
export type SubscriptionId = z.infer<typeof SubscriptionIdSchema> | string;

/**
 * A subscription of an organization.
 */
export interface Subscription extends IBaseEntity {
    id: SubscriptionId;
    organizationId: OrganizationId;
    stripeSubscriptionId?: string | null;
    plan: SubscriptionPlan;
    status: SubscriptionStatus;
    credits: number;
    domains: number;
    features: Features;
    currentPeriodStart: Date;
    currentPeriodEnd: Date;
    organization: Organization;
}
